import styled from "styled-components"
// import { LogOut } from "react-feather";

export default styled.img`
  max-width: 115px;
  height: auto;
`;


// WEBPACK FOOTER //
// ./src/components/logo/logo.component.js